import { Checkbox, message, Radio, RadioChangeEvent, Rate, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { CiHeart } from "react-icons/ci";
import { GoShareAndroid } from "react-icons/go";
import { IoCartSharp, IoSearchOutline } from "react-icons/io5";
import ProdDesc from "./ProdDesc";
import { IoIosArrowUp } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../API/config";
import moment from "moment";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { eventManager } from "../EventEmitter";

interface Variant {
  storage: string;
  ramSize: string;
  colorName: string;
  connectivity: string;
}

const ProdDetails = () => {
  const [value, setValue] = useState("standard delivery");
  const [valueExchange, setValueExchange] = useState("without exchange");
  const [startIndex, setStartIndex] = useState(0);
  const visibleImagesCount = 3;

  const [selectedValues, setSelectedValues] = useState({
    ram: "",
    storage: "",
    color: "",
    id: "",
    connectivity: "",
  });

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  const onChangeExchange = (e: RadioChangeEvent) => {
    setValueExchange(e.target.value);
  };

  const listArray = [
    "/assets/laptop.png",
    "/assets/proddeal.png",
    "/assets/laptop.png",
    "/assets/proddeal.png",
    "/assets/laptop.png",
  ];
  const [currentIndex, setcurrentIndex] = useState(0);
  const handlenextvimg = () => {
    if (startIndex + visibleImagesCount < listArray.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleprevimg = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const handleDisplayimage = (index: any) => {
    setcurrentIndex(index);
  };

  const { category, slug } = useParams();

  const [messageApi, contextHolder] = message.useMessage();

  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const [ogData, setOgData] = useState<any>();

  const [ogPincode, setOGPincode] = useState<any[]>([]);
  const [pincodeValue, setPincodeValue] = useState("");
  const [pincodeRes, setPincodeRes] = useState<any[]>([]);
  const [activeVariant, setActiveVariant] = useState<Variant | null>(null);
  const [images, setImages] = useState([]);

  const handleGetProdbyslug = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/products/slug/${slug}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOgData(res.data);
      await handlegetPincode();
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const dealPrice = parseFloat(ogData?.variants[0].dealPrice);
  const price = parseFloat(ogData?.variants[0].price);
  const discountless = price - dealPrice;
  const discountPercentage = ((price - dealPrice) / price) * 100;

  const handlegetPincode = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/delivery-info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOGPincode(res.data);
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handlePincodeFilter = () => {
    const estimateDate = ogPincode.filter(
      (val) => val.pincode === pincodeValue
    );

    if (!estimateDate.length) {
      message.error("Delivery not available for this pincode!");
      return;
    }

    setPincodeRes(estimateDate);
  };

  const handleColorChange = (val: any) => {
    setActiveVariant(val);
    setImages(val.images);
    setSelectedValues({ ...selectedValues, color: val.colorName, id: val._id });
  };

  const handleShareLink = () => {
    const currentUrl = window.location.href;
    const shareData = {
      title: ogData?.title || "Check out this product!",
      text: "I found this amazing product and wanted to share it with you!",
      url: currentUrl,
    };

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => {
          console.log("Share successful");
        })
        .catch((error) => {
          console.error("Error sharing:", error);
        });
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  useEffect(() => {
    handleGetProdbyslug();
    getMe();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [slug]);

  useEffect(() => {
    if (ogData?.variants && ogData.variants.length > 0) {
      setActiveVariant(ogData.variants[0]);
      setImages(ogData.variants[0].images);
    }
  }, [ogData]);

  const [priceUpdate, setPriceUpdate] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [errorMessages, setErrorMessage] = useState("");
  const handleQuerydata = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const storageValue =
        selectedValues.storage || (activeVariant ? activeVariant.storage : "");
      const ramValue =
        selectedValues.ram || (activeVariant ? activeVariant.ramSize : "");
      const colorValue =
        selectedValues.color || (activeVariant ? activeVariant.colorName : "");
      const connectivity =
        selectedValues.connectivity ||
        (activeVariant ? activeVariant.connectivity : "");

      // Build query parameters dynamically based on non-empty values
      const queryParams = new URLSearchParams();

      if (storageValue) {
        queryParams.append("variantStorage", storageValue);
      }

      if (ramValue) {
        queryParams.append("variantramSize", ramValue);
      }

      if (colorValue) {
        queryParams.append("variantColor", colorValue);
      }

      if (connectivity) {
        queryParams.append("connectivity", connectivity);
      }

      const res = await axios.get(
        `${API_URL}/api/products/variant/${
          ogData._id
        }?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setErrorMessage("");
      setPriceUpdate(res.data.product);
    } catch (error: any) {
      setPriceUpdate(null);
      setErrorMessage(error?.response?.data?.message);
    }
  };

  const getMe = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(res.data.user);
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleWishlist = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const wishData = {
        productId: data._id,
        variantDetails: {
          storage: data.variants[0].storage,
          colorName: data.variants[0].colorName,
          ramSize: data.variants[0].ramSize,
        },
      };
      await axios.post(`${API_URL}/api/user/wishlist`, wishData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      eventManager.emit("cartUpdated");
      success("Added to Wishlist");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleremoveWishlist = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const wishData = {
        productId: data._id,
        variantId: data.variants[0]._id,
      };

      await axios.delete(`${API_URL}/api/user/wishlist/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: wishData,
      });
      eventManager.emit("cartUpdated");
      success("Removed from Wishlist");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleCart = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const cartData = {
        productId: ogData._id,
        variantDetails: {
          storage: selectedValues.storage
            ? selectedValues.storage
            : ogData.variants[0].storage,
          colorName: selectedValues.color
            ? selectedValues.color
            : ogData.variants[0].colorName,
          ramSize: selectedValues.ram
            ? selectedValues.ram
            : ogData.variants[0].ramSize,
        },
        DeliveryType: value ? value : "Standard delivery",
        ExchangeType: valueExchange ? valueExchange : "without exchange",
        pincode: pincodeValue ? pincodeValue : "",
        boughtTogether: [],
      };
      await axios.post(`${API_URL}/api/user/cart`, cartData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      eventManager.emit("cartUpdated");
      navigate("/cart");
      success("Added to cart");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage("Login required!");
    }
  };

  const handleremoveCart = async (data: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }

    try {
      const cartData = {
        productId: data._id,
        variantId: data.variant._id,
      };

      await axios.delete(`${API_URL}/api/user/cart/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: cartData,
      });
      success("Removed from cart");
      eventManager.emit("cartUpdated");
      await getMe();
    } catch (error: any) {
      console.log(error);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const isProductInCart = (productId: string) => {
    return userData?.cart.some((item: any) => item.product === productId);
  };

  const isProductInWishlist = (productId: string) => {
    return userData?.wishlist.some((item: any) => item.product === productId);
  };
  const navigate = useNavigate();

  const handletogether = async (dts: any) => {
    await handleCart();
    if (Array.isArray(dts.boughtTogether)) {
      const boughtTogetherParam = dts.boughtTogether.join(",");
      navigate(`/buy-together?boughtTogether=${boughtTogetherParam}`);
    } else {
      console.error("boughtTogether is not an array:", dts.boughtTogether);
    }
  };

  useEffect(() => {
    handleQuerydata();
  }, [selectedValues]);

  return (
    <>
      {contextHolder}
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">
              Home - Products-{category}-{ogData?.product || "-"}
            </p>

            <h2 className="title-navhead">Products</h2>
          </div>
          <div className="row pt-4 pb-3">
            <div className="col-lg-1 col-md-3 col-sm-12 col-12">
              <div className="na-div">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="upicons" onClick={handlenextvimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
                <div className="map-div">
                  {images.length > 0 &&
                    images
                      .slice(startIndex, startIndex + visibleImagesCount)
                      .map((imgSrc, index) => {
                        const realIndex = startIndex + index;
                        return (
                          <div
                            className={`arr-div ${
                              currentIndex === realIndex
                                ? "active-thumbnail"
                                : ""
                            }`}
                            key={realIndex}
                            onClick={() => handleDisplayimage(realIndex)}
                          >
                            <img src={imgSrc} className="img-fluid" />
                          </div>
                        );
                      })}
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="downicons" onClick={handleprevimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-9 col-sm-12 col-12 p-2">
              <div className="prod-con">
                <div className="">
                  <img
                    src={images[currentIndex]}
                    className="img-fluid proddeal-img mt-5"
                  />
                </div>
                <div className="deal-img">
                  <img className="img-fluid" src="/assets/deal.png" />
                </div>
                <div className="deal-imgicon d-flex">
                  {isProductInWishlist(ogData?._id) ? (
                    <div
                      className="me-2"
                      onClick={() => handleremoveWishlist(ogData)}
                    >
                      {" "}
                      <FaHeart
                        style={{ color: "red", cursor: "pointer" }}
                      />{" "}
                    </div>
                  ) : (
                    <div
                      className="me-2"
                      onClick={() => handleWishlist(ogData)}
                    >
                      {" "}
                      <FaRegHeart style={{ cursor: "pointer" }} />{" "}
                    </div>
                  )}
                  <GoShareAndroid
                    style={{ cursor: "pointer" }}
                    onClick={handleShareLink}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-12 col-12 p-2">
              <div className="details-box">
                <div>
                  <h3>
                    {ogData?.product + "," || ""}
                    {ogData?.description.screenSize + "," || ""}
                    {ogData?.description.camera + "main camera," || ""}
                    {ogData?.description.battery + "battery," || ""}
                    {activeVariant?.colorName || ""}
                  </h3>
                  {ogData?.rating > 0 && (
                    <>
                      <Rate
                        disabled
                        value={ogData?.rating}
                        allowHalf
                        style={{ fontSize: "14px" }}
                      />
                      <span className="prod-rateing">
                        {ogData?.rating || "-"}|
                        {ogData?.BoughtCount + " Bought" || "-"}
                      </span>
                    </>
                  )}
                  <p className="prod-id">
                    <span>
                      <strong>Product id :</strong>
                    </span>{" "}
                    {ogData?._id.slice(-5) || "-"}
                    {""}
                    {priceUpdate?.selectedVariant?.inStock && (
                      <span
                        className="px-2 py-1 mx-2"
                        style={{
                          backgroundColor: "#2FB300",
                          borderRadius: "20px",
                          height: "15px",
                          width: "50px",
                          color: "#fff",
                          fontSize: "10px",
                        }}
                      >
                        In Stock
                      </span>
                    )}
                    {errorMessages && (
                      <span
                        className="px-2 py-1 mx-2"
                        style={{
                          backgroundColor: "red",
                          borderRadius: "20px",
                          height: "15px",
                          width: "50px",
                          color: "#fff",
                          fontSize: "10px",
                        }}
                      >
                        Out of Stock
                      </span>
                    )}
                  </p>
                  {discountPercentage > 0 && (
                    <p className="mb-0">
                      <span
                        className="me-2"
                        style={{
                          textDecoration: "line-through",
                          color: "#6C6C6C",
                          fontSize: "12px",
                          fontWeight: 400,
                        }}
                      >
                        MPR ₹{" "}
                        {priceUpdate?.selectedVariantPrice.price ||
                          ogData?.variants[0].price ||
                          "-"}
                      </span>
                      <span
                        style={{
                          color: "#2FB300",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        Save{" "}
                        {ogData.variants[0].price -
                          ogData.variants[0].dealPrice}{" "}
                        {`(${discountPercentage.toFixed()} %)`}
                      </span>
                    </p>
                  )}

                  <h2 className="price-single">
                    ₹{" "}
                    {priceUpdate?.selectedVariantPrice.dealPrice ||
                      ogData?.variants[0].dealPrice.toFixed(2) ||
                      "-"}{" "}
                    <span>(Include all taxes)</span>
                  </h2>
                  {ogData?.variants.some((val: any) => val.connectivity) && (
                    <>
                      <h3>Connectivity</h3>
                      <div className="py-2">
                        {ogData?.variants.map((val: any) => (
                          <Button
                            variant="contained"
                            className={`ram-btn mx-1 ${
                              selectedValues.connectivity === val.connectivity
                                ? "activeRam"
                                : ""
                            }`}
                            onClick={() =>
                              setSelectedValues({
                                ...selectedValues,
                                connectivity: val.connectivity,
                              })
                            }
                          >
                            {val.connectivity}
                          </Button>
                        ))}
                      </div>
                    </>
                  )}
                  {ogData?.variants.some((val: any) => val.ramSize) && (
                    <>
                      <h3>Ram</h3>
                      <div className="py-2">
                        {Array.from(
                          new Set<string>(
                            ogData?.variants.map((val: any) => val.ramSize)
                          )
                        ).map((ramSize) => (
                          <Button
                            key={ramSize} // Type is explicitly defined as string
                            variant="contained"
                            className={`ram-btn mx-1 ${
                              selectedValues.ram === ramSize ? "activeRam" : ""
                            }`}
                            onClick={() =>
                              setSelectedValues({
                                ...selectedValues,
                                ram: ramSize, // Ensure ram is a string
                              })
                            }
                          >
                            {ramSize} {/* Ensure ramSize is a string */}
                          </Button>
                        ))}
                      </div>
                    </>
                  )}

                  {ogData?.variants.some((val: any) => val.storage) && (
                    <>
                      <h3>Storage</h3>
                      <div className="py-2">
                        {Array.from(
                          new Set<string>(
                            ogData?.variants.map((val: any) => val.storage)
                          )
                        ).map((storage) => (
                          <Button
                            key={storage}
                            variant="contained"
                            className={`ram-btn mx-1 ${
                              selectedValues.storage === storage
                                ? "activeRam"
                                : ""
                            }`}
                            onClick={() =>
                              setSelectedValues({
                                ...selectedValues,
                                storage,
                              })
                            }
                          >
                            {storage}
                          </Button>
                        ))}
                      </div>
                    </>
                  )}

                  {ogData?.variants.some((val: any) => val.colorName) && (
                    <>
                      <h3>Color</h3>
                      <div className="d-flex justify-content-start align-items-center py-2">
                        {Array.from(
                          new Map(
                            ogData?.variants.map((variant: any) => [
                              variant.colorName,
                              variant,
                            ])
                          ).values()
                        ).map((variant: any) => (
                          <div
                            key={variant._id}
                            className="me-2 d-flex justify-content-center align-items-center flex-column"
                          >
                            <div
                              className={`${
                                activeVariant?.colorName === variant.colorName
                                  ? "color-border"
                                  : "color-borderinActive"
                              }`}
                            >
                              <div
                                className={`color-card ${
                                  activeVariant === variant.colorCode
                                    ? "color-cardActive"
                                    : "color-cardInactive"
                                }`}
                                style={{
                                  backgroundColor: variant.colorCode,
                                  cursor: "pointer",
                                }}
                                onClick={() => handleColorChange(variant)}
                              ></div>
                              {/* <p style={{ fontSize: "14px" }}>{variant?.colorName}</p> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  <h3 className="pt-3">Enter your pincode</h3>
                  <div className="pin-code">
                    <input
                      className="p-2"
                      onChange={(e) => setPincodeValue(e.target.value)}
                    />
                    <Button onClick={handlePincodeFilter}>
                      <IoSearchOutline />
                    </Button>
                  </div>
                  <span className="del">
                    {pincodeRes.length > 0 && "Delivery by :"}
                    {pincodeRes.length > 0
                      ? value === "standard delivery"
                        ? moment()
                            .add(pincodeRes[0].standardDeliveryDate, "days")
                            .format("DD MMM YYYY")
                        : moment()
                            .add(pincodeRes[0].expressDeliveryDate, "days")
                            .format("DD MMM YYYY")
                      : ""}
                  </span>

                  <h3 className="pt-3">Delivery Type</h3>
                  <div>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio value={"standard delivery"}>
                          Standard Delivery
                        </Radio>
                        <Radio value={"Express Delivery"}>
                          Express Delivery
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Exchange Type</h3>
                  <div>
                    <Radio.Group
                      onChange={onChangeExchange}
                      value={valueExchange}
                    >
                      <Space direction="vertical">
                        <Radio value={"with exchange"}>With Exchange</Radio>
                        <Radio value={"without exchange"}>
                          Without Exchange
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Description</h3>
                  <table>
                    {ogData?.brand && (
                      <tr>
                        <td className="td-desc">Brand</td>
                        <td className="td-descCon">: {ogData?.brand || "-"}</td>
                      </tr>
                    )}

                    {ogData?.description?.model && (
                      <tr>
                        <td className="td-desc">Model</td>
                        <td className="td-descCon">
                          : {ogData?.description?.model || "-"}
                        </td>
                      </tr>
                    )}

                    {ogData?.description?.screenSize && (
                      <tr>
                        <td className="td-desc">Screen Size</td>
                        <td className="td-descCon">
                          : {ogData?.description?.screenSize || "-"}
                        </td>
                      </tr>
                    )}

                    {ogData?.description?.camera && (
                      <tr>
                        <td className="td-desc">Camera Size</td>
                        <td className="td-descCon">
                          : {ogData.description.camera}
                        </td>
                      </tr>
                    )}

                    {ogData?.variants[0]?.watchSize && (
                      <tr>
                        <td className="td-desc">Watch size</td>
                        <td className="td-descCon">
                          : {ogData?.variants[0]?.watchSize || "-"}
                        </td>
                      </tr>
                    )}

                    {ogData?.variants[0]?.watchStyle && (
                      <tr>
                        <td className="td-desc">Watch Style</td>
                        <td className="td-descCon">
                          : {ogData?.variants[0]?.watchStyle || "-"}
                        </td>
                      </tr>
                    )}
                    {ogData?.variants[0]?.watchConnection && (
                      <tr>
                        <td className="td-desc">Connection</td>
                        <td className="td-descCon">
                          : {ogData?.variants[0]?.watchConnection || "-"}
                        </td>
                      </tr>
                    )}

                    {ogData?.description?.processor && (
                      <tr>
                        <td className="td-desc">Processor</td>
                        <td className="td-descCon">
                          : {ogData?.description?.processor || "-"}
                        </td>
                      </tr>
                    )}
                  </table>

                  <div
                    className="img-divs justify-content-between"
                    style={{ width: "80%" }}
                  >
                    <div>
                      <img className="img-fluid" src="/assets/Group 1343.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1344.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1345.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1346.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="single-prodcart">
        <Container>
          <div className="">
            <div className="row">
              <div className="col-lg-1 col-md-1 col-sm-2 col-2">
                <div>
                  <img
                    className="img-fluid"
                    src="/assets/phone 1.png"
                    style={{
                      width: "84px",
                      height: "100px",
                      objectFit: "contain",
                      maxWidth: "85px",
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-10 col-10">
                <div className="ms-2">
                  <h2 className="price-single">
                    {priceUpdate?.product || ogData?.product}{" "}
                    {priceUpdate?.selectedVariant?.ramSize &&
                      `(${priceUpdate.selectedVariant.ramSize + "," || ""} ${
                        priceUpdate.selectedVariant.storage + "," || ""
                      } ${priceUpdate.selectedVariant.colorName || ""})`}
                  </h2>

                  <p className="mb-0">
                    {discountPercentage > 0 && (
                      <span
                        className="me-2"
                        style={{
                          textDecoration: "line-through",
                          color: "#6C6C6C",
                          fontSize: "12px",
                          fontWeight: 400,
                        }}
                      >
                        MRP ₹{" "}
                        {priceUpdate?.selectedVariant?.price ||
                          (ogData?.variants[0].price ?? 0).toFixed(2)}
                      </span>
                    )}
                    {discountPercentage > 0 && (
                      <span
                        style={{
                          color: "#2FB300",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        Save {discountless || "-"}{" "}
                        {`(${discountPercentage.toFixed() || "-"} %)`}
                      </span>
                    )}
                  </p>
                  <h2 className="price-single">
                    ₹{" "}
                    {priceUpdate?.selectedVariant?.dealPrice ||
                      (ogData?.variants[0].dealPrice ?? 0).toFixed(2) ||
                      "-"}{" "}
                    <span>(Include all taxes)</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <div className="sing-para">
                  {priceUpdate?.selectedVariant?.inStock && (
                    <p>
                      <img
                        className="img-fluid"
                        style={{ width: "20px" }}
                        src="/assets/fire.png"
                      />
                      Limited stock available
                    </p>
                  )}
                  {ogData?.boughtTogether.length > 0 && (
                    <Button onClick={() => handletogether(ogData)}>
                      Continue
                    </Button>
                  )}

                  {isProductInCart(ogData?._id) ? (
                    <Button style={{ cursor: "pointer" }}>Added to Cart</Button>
                  ) : (
                    <Button style={{ cursor: "pointer" }} onClick={handleCart}>
                      Add to Cart
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <ProdDesc product={ogData} />
    </>
  );
};

export default ProdDetails;
